import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { switchMap } from 'rxjs/operators';
import { throwError, of, Observable } from 'rxjs';
import { SupportCategory, SupportInput } from '../models/support';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class SupportService {

  constructor(private api: ApiService, private auth: AuthService) { }

  getCategories(): Observable<SupportCategory[]> {
    return this.api.get(`{
      contactFormCategories{
        key
        name
      }
    }`, null, this.auth.getToken() ? true : false).pipe(
      switchMap(response => {
        if (response['errors']) {
          return throwError(response);
        }

        return of(response['data']['contactFormCategories']);
      }),
      this.api.unifyErrors()
    );
  }

  send(categoryKey: string, payload: SupportInput): Observable<boolean> {
    return this.api.get(`mutation sendContactForm($categoryKey: String!, $payload: ContactFormInput!) {
      sendContactForm(
        categoryKey: $categoryKey,
        payload: $payload
      ){
        ... on GeneralResponse{
          success
        }
        ... on OperationError{
          errors{
            message
            field
          }
        }
    }
  }`, {
    categoryKey: categoryKey,
    payload: payload
  }, this.auth.getToken() ? true : false).pipe(
    switchMap(response => {
      const data = response['data']['sendContactForm'];

      if (data['errors']) {
        return throwError(data);
      }

      return of(data['success']);
    }),
    this.api.unifyErrors()
  );
  }
}
